import img from "../../img/23Architecture.webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsStructurePage() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>STRUCTURE</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">
            Structures métallo-textiles architecturales
          </h1>

          <p data-aos="fade-up">
            Solutions de structures métallo-textiles avec toiles
            techniques traitées PVDF, offrant durabilité,
            luminosité naturelle et portées importantes.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-structure.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Structure métallo-textile" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US STRUCTURE ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US STRUCTURE est une solution de couverture
            métallo-textile utilisant des toiles techniques
            traitées PVDF, résistantes aux salissures et
            aux conditions climatiques.
          </p>

          <p data-aos="fade-up">
            Ces structures permettent de couvrir de grandes
            portées tout en offrant une luminosité naturelle,
            avec des versions translucides ou opaques.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature icon="🏗️" title="Grandes portées" text="Adapté aux structures architecturales importantes." />
          <Feature icon="☀️" title="Luminosité naturelle" text="Toiles translucides ou opaques selon les besoins." />
          <Feature icon="🎨" title="Large gamme de couleurs" text="Personnalisation esthétique des structures." />
          <Feature icon="🧱" title="Traitement PVDF" text="Protection anti-salissures et durabilité accrue." />
          <Feature icon="📦" title="Produits en stock" text="Disponibilité rapide pour vos projets." />
          <Feature icon="🛡️" title="Garantie longue durée" text="Garantie de 10 à 25 ans selon les solutions." />
        </div>
      </section>

      {/* TECHNIQUE */}
<section className="us-section">
  <SectionTitle
    small="Technique"
    big="Caractéristiques techniques"
  />

  <ul data-aos="fade-up" className="us-list">
    <li>Structures métallo-textiles à grande portée</li>
    <li>Toiles avec traitement de surface PVDF</li>
    <li>Protection anti-salissures</li>
    <li>Produits translucides ou opaques disponibles</li>
    <li>Apport de luminosité naturelle</li>
    <li>Large gamme de couleurs</li>
    <li>Garantie de 10 à 25 ans</li>
  </ul>
</section>

{/* APPLICATIONS */}
<section className="us-section us-gray">
  <SectionTitle
    small="Applications"
    big="Domaines d’utilisation"
  />

  <div className="us-tags" data-aos="fade-up">
    {[
      "Centres commerciaux",
      "Stades",
      "Bâtiments industriels",
      "Halls d’exposition",
      "Parkings",
      "Espaces publics",
      "Gares",
      "Aéroports",
      "Zones logistiques",
      "Structures événementielles",
    ].map((item) => (
      <span key={item}>{item}</span>
    ))}
  </div>
</section>


      {/* CTA */}
      <section className="us-cta">
        <h2>Besoin d’une structure textile sur mesure ?</h2>
        <p>Nos équipes vous accompagnent dans votre projet.</p><br/>
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
